import Vue from 'vue';
import options from './index.vue'
Vue.component('tg-fixed-bar', options);
import maple from 'maple';
var tabBarConnectData = [];
export let autoChangeByComListFixed = function(connectComList, httpUrl, index, currentIndex){
	// 自动处理被关联的组件
	if( connectComList.length ){
		connectComList.forEach(com =>{
			var comData = maple.pageIns.vm.$get(com);
			tabBarConnectData[currentIndex] = tabBarConnectData[currentIndex] || {};
			if( comData ){
				tabBarConnectData[currentIndex][com] = JSON.parse(JSON.stringify(comData))
			}
			maple.pageIns.vm.$delete(com);
		});
		$('body').css('height', 'auto');
		tabBarConnectData[currentIndex].loadMoreUrl = maple.pageIns.getLoadMoreUrl();
		_.delay(function(){
			if( tabBarConnectData[index] ){
				for(let com in tabBarConnectData[index]){
					maple.pageIns.vm.$set(com, tabBarConnectData[index][com]);
				}
				maple.pageIns.setLoadMoreUrl(tabBarConnectData[index].loadMoreUrl);
				maple.pageIns.vm.$broadcast('midDataNoMore', !!tabBarConnectData[index].loadMoreUrl);
			}else{
				maple.pageIns.loadMidData(httpUrl)
			}
		})
	}
};